module.exports = __webpack_public_path__ + "img/advantages-add.d6088488.png";